function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
var m = Object.defineProperty;
var p = function p(s, r, t) {
  return r in s ? m(s, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: t
  }) : s[r] = t;
};
var a = function a(s, r, t) {
  return p(s, _typeof(r) != "symbol" ? r + "" : r, t);
};
import { BoxedEditorUIView as b, StickyPanelView as y, ToolbarView as v, MenuBarView as P, InlineEditableUIView as k, EditorUI as T, normalizeToolbarConfig as V, DialogView as f } from "../../../../../@ckeditor_ckeditor5-ui@45.1.0/node_modules/@ckeditor/ckeditor5-ui/dist/index.js";
import { enablePlaceholder as C } from "../../../../../@ckeditor_ckeditor5-engine@45.1.0/node_modules/@ckeditor/ckeditor5-engine/dist/index.js";
import { CKEditorError as B, getDataFromElement as E, ElementReplacer as S, Rect as h } from "../../../../../@ckeditor_ckeditor5-utils@45.1.0/node_modules/@ckeditor/ckeditor5-utils/dist/index.js";
import { ElementApiMixin as _, attachToForm as R, Editor as x } from "../../../../../@ckeditor_ckeditor5-core@45.1.0/node_modules/@ckeditor/ckeditor5-core/dist/index.js";
import { isElement as F } from "../../../../../es-toolkit@1.32.0/node_modules/es-toolkit/dist/compat/predicate/isElement.js"; /**
                                                                                                                              * @license Copyright (c) 2003-2025, CKSource Holding sp. z o.o. All rights reserved.
                                                                                                                              * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-licensing-options
                                                                                                                              */
var I = /*#__PURE__*/function (_T) {
  function I(t, i) {
    var _this;
    _classCallCheck(this, I);
    _this = _callSuper(this, I, [t]);
    a(_this, "view");
    a(_this, "_toolbarConfig");
    a(_this, "_elementReplacer");
    _this.view = i, _this._toolbarConfig = V(t.config.get("toolbar")), _this._elementReplacer = new S(), _this.listenTo(t.editing.view, "scrollToTheSelection", _this._handleScrollToTheSelectionWithStickyPanel.bind(_this));
    return _this;
  }
  _inherits(I, _T);
  return _createClass(I, [{
    key: "element",
    get: function get() {
      return this.view.element;
    }
  }, {
    key: "init",
    value: function init(t) {
      var i = this.editor,
        o = this.view,
        n = i.editing.view,
        e = o.editable,
        l = n.document.getRoot();
      e.name = l.rootName, o.render();
      var c = e.element;
      this.setEditableElement(e.name, c), o.editable.bind("isFocused").to(this.focusTracker), n.attachDomRoot(c), t && this._elementReplacer.replace(t, this.element), this._initPlaceholder(), this._initToolbar(), o.menuBarView && this.initMenuBar(o.menuBarView), this._initDialogPluginIntegration(), this._initContextualBalloonIntegration(), this.fire("ready");
    }
  }, {
    key: "destroy",
    value: function destroy() {
      _superPropGet(I, "destroy", this, 3)([]);
      var t = this.view,
        i = this.editor.editing.view;
      this._elementReplacer.restore(), i.getDomRoot(t.editable.name) && i.detachDomRoot(t.editable.name), t.destroy();
    }
  }, {
    key: "_initToolbar",
    value: function _initToolbar() {
      var t = this.view;
      t.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t.stickyPanel.limiterElement = t.element, t.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", function (_ref) {
        var i = _ref.visualTop;
        return i || 0;
      }), t.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(t.toolbar);
    }
  }, {
    key: "_initPlaceholder",
    value: function _initPlaceholder() {
      var t = this.editor,
        i = t.editing.view,
        o = i.document.getRoot(),
        n = t.sourceElement;
      var e;
      var l = t.config.get("placeholder");
      l && (e = typeof l == "string" ? l : l[this.view.editable.name]), !e && n && n.tagName.toLowerCase() === "textarea" && (e = n.getAttribute("placeholder")), e && (o.placeholder = e), C({
        view: i,
        element: o,
        isDirectHost: !1,
        keepOnFocus: !0
      });
    }
  }, {
    key: "_initContextualBalloonIntegration",
    value: function _initContextualBalloonIntegration() {
      if (!this.editor.plugins.has("ContextualBalloon")) return;
      var t = this.view.stickyPanel,
        i = this.editor.plugins.get("ContextualBalloon");
      i.on("getPositionOptions", function (n) {
        var e = n.return;
        if (!e || !t.isSticky || !t.element) return;
        var l = new h(t.element).height,
          c = typeof e.target == "function" ? e.target() : e.target,
          u = typeof e.limiter == "function" ? e.limiter() : e.limiter;
        if (c && u && new h(c).height >= new h(u).height - l) return;
        var g = _objectSpread({}, e.viewportOffsetConfig),
          w = (g.top || 0) + l;
        n.return = _objectSpread(_objectSpread({}, e), {}, {
          viewportOffsetConfig: _objectSpread(_objectSpread({}, g), {}, {
            top: w
          })
        });
      }, {
        priority: "low"
      });
      var o = function o() {
        i.visibleView && i.updatePosition();
      };
      this.listenTo(t, "change:isSticky", o), this.listenTo(this.editor.ui, "change:viewportOffset", o);
    }
  }, {
    key: "_handleScrollToTheSelectionWithStickyPanel",
    value: function _handleScrollToTheSelectionWithStickyPanel(t, i, o) {
      var _this2 = this;
      var n = this.view.stickyPanel;
      if (n.isSticky) {
        var e = new h(n.element).height;
        i.viewportOffset.top += e;
      } else {
        var _e = function _e() {
          _this2.editor.editing.view.scrollToTheSelection(o);
        };
        this.listenTo(n, "change:isSticky", _e), setTimeout(function () {
          _this2.stopListening(n, "change:isSticky", _e);
        }, 20);
      }
    }
  }, {
    key: "_initDialogPluginIntegration",
    value: function _initDialogPluginIntegration() {
      if (!this.editor.plugins.has("Dialog")) return;
      var t = this.view.stickyPanel,
        i = this.editor.plugins.get("Dialog");
      i.on("show", function () {
        var o = i.view;
        o.on("moveTo", function (n, e) {
          if (!t.isSticky || o.wasMoved || o.isModal) return;
          var l = new h(t.contentPanelElement);
          e[1] < l.bottom + f.defaultOffset && (e[1] = l.bottom + f.defaultOffset);
        }, {
          priority: "high"
        });
      }, {
        priority: "low"
      });
    }
  }]);
}(T);
var D = /*#__PURE__*/function (_b) {
  function D(t, i) {
    var _this3;
    var o = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    _classCallCheck(this, D);
    _this3 = _callSuper(this, D, [t]);
    a(_this3, "stickyPanel");
    a(_this3, "toolbar");
    a(_this3, "editable");
    _this3.stickyPanel = new y(t), _this3.toolbar = new v(t, {
      shouldGroupWhenFull: o.shouldToolbarGroupWhenFull
    }), o.useMenuBar && (_this3.menuBarView = new P(t)), _this3.editable = new k(t, i, void 0, {
      label: o.label
    });
    return _this3;
  }
  _inherits(D, _b);
  return _createClass(D, [{
    key: "render",
    value: function render() {
      _superPropGet(D, "render", this, 3)([]), this.menuBarView ? this.stickyPanel.content.addMany([this.menuBarView, this.toolbar]) : this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
    }
  }]);
}(b);
var H = /*#__PURE__*/function (_ref2) {
  function H(t) {
    var _this4;
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    _classCallCheck(this, H);
    if (!d(t) && i.initialData !== void 0) throw new B("editor-create-initial-data", null);
    _this4 = _callSuper(this, H, [i]);
    a(_this4, "ui");
    _this4.config.define("menuBar.isVisible", !1), _this4.config.get("initialData") === void 0 && _this4.config.set("initialData", M(t)), d(t) && (_this4.sourceElement = t), _this4.model.document.createRoot();
    var o = !_this4.config.get("toolbar.shouldNotGroupWhenFull"),
      n = _this4.config.get("menuBar"),
      e = new D(_this4.locale, _this4.editing.view, {
        shouldToolbarGroupWhenFull: o,
        useMenuBar: n.isVisible,
        label: _this4.config.get("label")
      });
    _this4.ui = new I(_this4, e), R(_this4);
    return _this4;
  }
  _inherits(H, _ref2);
  return _createClass(H, [{
    key: "destroy",
    value: function destroy() {
      return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), _superPropGet(H, "destroy", this, 3)([]);
    }
  }], [{
    key: "editorName",
    get: function get() {
      return "ClassicEditor";
    }
  }, {
    key: "create",
    value: function create(t) {
      var _this5 = this;
      var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return new Promise(function (o) {
        var n = new _this5(t, i);
        o(n.initPlugins().then(function () {
          return n.ui.init(d(t) ? t : null);
        }).then(function () {
          return n.data.init(n.config.get("initialData"));
        }).then(function () {
          return n.fire("ready");
        }).then(function () {
          return n;
        }));
      });
    }
  }]);
}(_(x));
function M(s) {
  return d(s) ? E(s) : s;
}
function d(s) {
  return F(s);
}
export { H as ClassicEditor, D as ClassicEditorUIView };